// This file will look in the page for matching divs and mount the corresponding components to them
import _ from "lodash";
import React from "react";
import { render } from "react-dom";
import DateRange from "./components/DateRange";
import RichText from "./components/RichText";
import DraftJS from "./components/DraftJS";
import Supertag from "./components/Supertag";
import ImageUploader from "./components/ImageUploader";
import DocUploader from "./components/DocUploader";
import FileLabelEditor from "./components/FileLabelEditor";
import Features from "./components/Features";
import Notes from "./components/Notes";
import VersionLock from "./components/VersionLock";
import Select from "./components/Select";
import AltTextGenerator from "./components/AltTextGenerator";

// Use this file to mount all the components defined in the components folder

Dropzone.autoDiscover = false;

function dateRangeInit() {
  document.querySelectorAll(".date-range-react").forEach((element) => {
    render(
      React.createElement(DateRange, {
        fromVal: element.dataset.fromval,
        fromFieldName: element.dataset.fromfieldname,
        fromLabel: element.dataset.fromlabel,
        toVal: element.dataset.toval,
        toFieldName: element.dataset.tofieldname,
        toLabel: element.dataset.tolabel,
        recordType: element.dataset.recordtype,
      }),
      element
    );
  });
}

dateRangeInit();

function altTextGeneratorInit() {
  document.querySelectorAll(".alt-text-generator-react").forEach((element) => {
    render(
      React.createElement(AltTextGenerator, {
        apiKey: element.dataset.apikey,
      }),
      element
    );
  });
}

altTextGeneratorInit();

function richTextInit() {
  document.querySelectorAll(".rich-text").forEach((element) => {
    render(
      React.createElement(RichText, {
        val: element.dataset.val,
        fieldName: element.dataset.fieldname,
        fieldId: element.dataset.fieldid,
        html: element.dataset.html === "true",
      }),
      element
    );
  });
}

richTextInit();

function draftJSInit() {
  document.querySelectorAll(".draftjs").forEach((element) => {
    render(
      React.createElement(DraftJS, {
        val: element.dataset.val,
        fieldName: element.dataset.fieldname,
        fieldId: element.dataset.fieldid,
        html: element.dataset.html === "true",
      }),
      element
    );
  });
}

draftJSInit();

function supertagInit() {
  document.querySelectorAll(".supertag").forEach((element) => {
    render(
      React.createElement(Supertag, {
        fieldName: element.dataset.fieldname,
        isNewProject: element.dataset.isnewproject === "new",
      }),
      element
    );
  });
}

supertagInit();

function imageUploaderInit() {
  document.querySelectorAll(".image-uploader").forEach((element) => {
    render(
      React.createElement(ImageUploader, {
        itemData: window.imgData,
        archivedItemData: window.archivedImgData,
        imageCreditElement: element.dataset.imagecreditelement,
        recordType: element.dataset.recordtype,
        recordId: element.dataset.recordid,
        maxFiles: element.dataset.maxfiles,
        averageImageSize: element.dataset.averageimagesize,
      }),
      element
    );
  });
}

imageUploaderInit();

function docUploaderInit() {
  document.querySelectorAll(".doc-uploader").forEach((element) => {
    render(
      React.createElement(DocUploader, {
        itemData: window.docData,
        archivedItemData: window.archivedDocData,
        recordType: element.dataset.recordtype,
        recordId: element.dataset.recordid,
        maxFiles: element.dataset.maxfiles,
      }),
      element
    );
  });
}

docUploaderInit();

// MutationObserver will dynamically mount more instances of this
// component as they are added or removed
function fileLabelEditorInit() {
  // Select the node that will be observed for mutations
  document
    .querySelectorAll(".doc-panel, .backup-panel")
    .forEach((targetNode) => {
      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = (mutationsList, observer) => {
        targetNode.querySelectorAll(".dz-success").forEach((element) => {
          const mountPoint = element.querySelector(".file-panel-label-editor");

          // if not already mounted
          if (
            mountPoint &&
            !mountPoint.childElementCount &&
            element.dataset.id
          ) {
            render(
              React.createElement(FileLabelEditor, {
                id: element.dataset.id,
                label: element.dataset.filelabel || "",
                filetype: mountPoint.dataset.filetype,
              }),
              mountPoint
            );
          }
        });
      };

      const debouncedCallback = _.debounce(callback, 100);

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(debouncedCallback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    });
}

fileLabelEditorInit();

function featuresInit() {
  document.querySelectorAll(".features").forEach((element) => {
    render(
      React.createElement(Features, {
        items: element.dataset.featurelist,
        recordType: element.dataset.recordtype,
      }),
      element
    );
  });
}

featuresInit();

function notesInit() {
  document.querySelectorAll(".notes-react").forEach((element) => {
    render(
      React.createElement(Notes, {
        items: element.dataset.items,
        recordId: element.dataset.recordid,
        recordType: element.dataset.recordtype,
        userId: element.dataset.userid,
      }),
      element
    );
  });
}

notesInit();

VersionLock();

// currently only working for "display_weight" field in projects
function selectInit() {
  document.querySelectorAll(".select-react").forEach((element) => {
    render(
      React.createElement(Select, { value: element.dataset.value }),
      element
    );
  });
}

selectInit();
